/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scheduleAllocationByResourceEntrySchema } from './scheduleAllocationByResourceEntrySchema';

export const scheduleAllocationByResourceResponseSchema = z.object({
  get entries() {
    return z
      .array(scheduleAllocationByResourceEntrySchema)
      .describe(
        'One entry per resource and team with planned time in the range, sorted by resourceId then teamId',
      );
  },
});
